import { SelectedElementDetails } from './index';

export const getComponentLink = (
  list: { library_type: string; obscure_key: string },
  actionType: string,
) => {
  return `/component/${actionType}/${list.library_type}/${list.obscure_key}`;
};

export const libraryTypes = {
  'All Interactives': '',
  Accordion: 'Accordion',
  Tabs: 'Tab',
  Button: 'Button',
  'Multiple Choice Question': 'multiplechoice',
  'Flip Card': 'flipcard',
  'Image/Video Slider ': 'imageslider',
  'Click & Reveal': 'ClickAndRevealInteractions',
  'Drag and Drop': 'DragandDrop',
  'Image Hotspot': 'Hotspot',
  Checklist: 'checklist',
};

export const getFeaturesList = (features: Record<string, boolean>, type: string) => {
  let config = {};
  config = {
    globalinteractive: features?.globalinteractive,
    sharedinteractive: features?.sharedinteractive,
    myinteractive: features?.myinteractive,
    globalinteractivecreate: features?.globalinteractivecreate,
    myinteractivecreate: features?.myinteractivecreate,
    globalinteractiveedit: features?.globalinteractiveedit,
    sharedinteractiveedit: features?.sharedinteractiveedit,
    myinteractiveedit: features?.myinteractiveedit,
    sharedinteractiveduplicate: features?.sharedinteractiveduplicate,
    globalinteractiveduplicate: features?.globalinteractiveduplicate,
    myinteractiveduplicate: features?.myinteractiveduplicate,
    collaborativeinteractivecreate: features?.collaborativeinteractivecreate,
    collaborativeinteractiveedit: features?.collaborativeinteractiveedit,
    edit: getEditType(features, type),
    delete: getDeleteType(features, type),
    duplicate: getDuplicateType(features, type),
    type: type === 'user' ? 'userInteractives' : '',
  };
  return config;
};
const getEditType = (features: Record<string, boolean>, type: string) => {
  if (type === 'global') {
    return features.globalinteractiveedit;
  } else if (type === 'shared') {
    return features.sharedinteractiveedit;
  } else {
    return features?.myinteractiveedit;
  }
};

const getDeleteType = (features: Record<string, boolean>, type: string) => {
  if (type === 'global') {
    return features.globalinteractivedelete;
  } else if (type === 'shared') {
    return features.sharedinteractivedelete;
  } else {
    return features?.myinteractivedelete;
  }
};

const getDuplicateType = (features: Record<string, boolean>, type: string) => {
  if (type === 'global') {
    return features.globalinteractiveduplicate;
  } else if (type === 'shared') {
    return features.sharedinteractiveduplicate;
  } else {
    return features?.myinteractiveduplicate;
  }
};

export const getAdminDashboardFontFamilyList = (configList: Record<string, {}>) => {
  return configList?.customFonts ?? {};
};

export const getCustomHeaderFontDetails = (configList: Record<string, {}>) => {
  return configList?.customHeaderStyle ?? {};
};

export const handleEmbedLINT = (selectedElementDetails: SelectedElementDetails) => {
  const event = {
    type: 'ADD_LINT',
    data: selectedElementDetails,
    url: window.location.href,
  };
  const url = document.referrer;
  if (url !== '' && document.referrer.indexOf(url) >= 0) {
    window.parent.postMessage(event, url);
  }
};

export const updateCollabInteractiveParent = () => {
  const event = {
    type: 'UPDATE_LINT',
  };
  const url = document.referrer;
  if (url !== '' && document.referrer.indexOf(url) >= 0) {
    window.parent.postMessage(event, url);
  }
};
